import { reducer as team } from "./team/slice";

export const reducer = {
  team,
};
